export type EmptyDetailPrompt = {
  emoji: string;
  text: string;
};

export const EMPTY_DETAIL_PROMPTS: EmptyDetailPrompt[] = [
  { emoji: "☕", text: "暂时没有新消息，喝口咖啡休息一下" },
  { emoji: "🌿", text: "当前很安静，适合整理一下思绪" },
  { emoji: "🎉", text: "所有会话都已处理完成，干得漂亮" },
  { emoji: "🤖", text: "AI 正在待命，随时准备响应下一条消息" },
  { emoji: "✨", text: "暂无待处理内容，你已经领先一步了" },
  { emoji: "📭", text: "收件箱空空的，今天效率不错" },
  { emoji: "😌", text: "暂时没有客户消息，可以稍微放松一下" },
  { emoji: "🚀", text: "一切运行正常，新的对话很快就会到来" },
  { emoji: "🌙", text: "现在没有新的动态，享受片刻平静" },
  { emoji: "💰", text: "每一次安静，都是下一次成交前的等待" },
];

export function pickEmptyDetailPrompt(): EmptyDetailPrompt {
  const index = Math.floor(Math.random() * EMPTY_DETAIL_PROMPTS.length);
  return EMPTY_DETAIL_PROMPTS[index];
}
